<template>
  <div class="product-rating-container">
    <div v-if="product.productInfos.RATE_ENABLED == 'true'" class="user-rating">
      <div class="avg d-flex justify-space-between align-center">
        <template v-if="product.ratingSummary.total > 0">
          <template>
            <div
              class="product-rating d-flex align-center"
              role="img"
              :aria-label="`${product.ratingSummary.avg} su 5 stelle`"
            >
              <v-icon
                v-for="n in 5"
                :key="n"
                small
                :color="getIconColor(n)"
                aria-hidden="true"
              >
                {{ getIcon(n) }}
              </v-icon>
            </div>
          </template>
          <span
            class="avg-total-count ml-2 ml-md-1 text-caption grey--text text--darken-1"
          >
            {{ product.ratingSummary.avg | number(1) }}|{{
              product.ratingSummary.total
            }}
            {{ $t("product.rating.productRating.review") }}
          </span>
        </template>
        <v-spacer></v-spacer>
        <!-- :to="{ name: 'Product', params: { slug: product.slug } }" -->
        <v-btn
          color="primary"
          v-if="showButton"
          text
          @click.prevent.stop=""
          @click="openVoteModal()"
        >
          {{ $t("product.rating.productRating.voteBtn") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.product-rating {
  pointer-events: none;

  .v-icon.v-icon--link,
  button {
    pointer-events: none !important;
    tabindex: -1;
  }
}
.product-rating-container {
  .user-rating .v-rating button {
    font-size: 16px !important;
  }
}
.product-card {
  .product-rating-container {
    border-top: 1px solid rgba(0, 0, 0, 0.12);
  }
}
</style>
<script>
import ProductCustomerVotes from "@/components/product/ProductCustomerVotes.vue";

export default {
  name: "ProductRating",
  props: {
    product: { type: Object, required: true },
    showButton: { type: Boolean, default: false }
  },
  data() {
    return {
      productVoteMaxRating: global.config.productVoteMaxRating
    };
  },
  methods: {
    getIcon(index) {
      const rating = this.product.ratingSummary.avg;

      if (rating >= index) {
        return "$ratingFull";
      }

      if (rating >= index - 0.5) {
        return "$ratingHalf";
      }

      return "$ratingFull";
    },

    getIconColor(index) {
      const rating = this.product.ratingSummary.avg;

      return rating >= index || rating >= index - 0.5 ? "promo" : "accent";
    },
    async openVoteModal() {
      let res = await this.$dialog.show(ProductCustomerVotes, {
        waitForResult: true,
        contentClass: "customer-votes-modal pa-5",
        productId: this.product.productId
      });
      console.log(res);
    }
  }
};
</script>
